module.exports = __webpack_public_path__ + "img/404.7bcc4fed.png";